var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{key:'composition-api-computed-pass-by'},[_c('img',{attrs:{"src":"/images/pass-by.gif","loading":"lazy"}})])}
var staticRenderFns = []

export { render, staticRenderFns }